<template>
    <wrapper>
        <div class="categories pb-1">
            <b-tabs v-model="tabIndex" pills nav-class="categories-tabs home-page-categories" active-nav-item-class="active-tab-class">
                <b-tab :title="$t('productCategories')" active>
                    <div class="row mt-5 product-image">
                        <b-col cols="12" md="6" xl="3" class="my-3 d-flex justify-content-center" v-for="category in categories" :key="category.id">
                            <router-link @mouseover="category.hover = true"
                                         @mouseleave="category.hover = false"
                                         class="text-dark"
                                         :to="`/categories?categoryName=${category.se_name}`">
                                <b-overlay :class="[{'hide-overlay-on-hover': !category.hover || windowsWidthSize() < 767 }, 'tab-item']"
                                           show
                                           :opacity="0.8"
                                           variant="dark">
                                    <b-card overlay
                                            :img-src="category.picture_model.image_url"
                                            :img-alt="category.picture_model.alternate_text"
                                            class="mx-auto">
                                    </b-card>

                                    <template #overlay>
                                        <div class="text-center text-light">
                                            <p id="cancel-label" v-html="category.description"></p>
                                        </div>
                                    </template>
                                </b-overlay>

                                <div class="categories-title mx-4 mx-md-0">{{ category.name }}</div>
                            </router-link>
                        </b-col>
                    </div>
                    <div class="text-center my-4">
                        <b-button variant="primary" class="btn-trimm-wide" pill @click="goTo(`/categories?categoryName=dc-power-distribution`)">{{ $t('seeMore') }}</b-button>
                    </div>
                </b-tab>

                <b-tab :title="$t('discoverBestSellers')" title-item-class="discover-best-sellers">
                    <div class="bestsellers mt-5 pt-3">
                        <Carousel :items-to-show="5"
                                  :wrap-around="true"
                                  :transition="500"
                                  :breakpoints="breakpoints"
                                  v-if="tabIndex === 1">
                            <Slide v-for="product in bestSellers" :key="'product_' + product.productId">
                                <div class="d-flex flex-column align-items-center">
                                    <b-card overlay class="border-0 bestsellers-card"
                                            :img-src="product.default_picture_model.image_url"
                                            :img-alt="product.default_picture_model.alternate_text">
                                        <b-card-text>
                                            <div class="bestsellers-btns d-none align-items-center flex-column">
                                                <b-button pill class="btn-bag mb-3 text-light" @click="requestQuote(product.id)">{{ $t('requestQuote') }}</b-button>
                                                <b-button pill class="btn-reload text-primary" @click="addToCompareList(product.id)">{{ $t('addToCompare') }}</b-button>
                                            </div>
                                        </b-card-text>
                                    </b-card>

                                    <div class="bestsellers-title text-center text-md-start ps-md-2">
                                        <router-link :to="product.custom_properties.product_url">{{ $t('part') }} #: {{ product.sku }}</router-link>
                                        <div>{{ product.short_description }}</div>
                                    </div>
                                </div>
                            </Slide>

                            <template #addons>
                                <Navigation />
                            </template>
                        </Carousel>
                    </div>
                    <div class="text-center my-4">
                        <b-button variant="primary" class="btn-trimm-wide" @click="goTo('/dc-power-distribution?view=all')" pill>{{ $t('seeMore') }}</b-button>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </wrapper>
</template>

<script>
    import QueryUtils from "@/utils/query-utils";
    import { catalogService, productService } from "@/services";
    import { ShoppingCartType } from "@/enums";
    import { shoppingCartService, wishlistService } from "@/services";
    import QuoteToast from "@/components/common/toasts/quote-toast.vue";
    import CompareToast from "@/components/common/toasts/compare-toast.vue";
    import { useToast } from "vue-toastification";
    import Wrapper from "@/components/common/wrapper.vue";
    import "vue3-carousel/dist/carousel.css";
    import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
    import seoMixin from "@/mixins/seo-mixin";

    export default {
        name: "categories",

        components: {
            wrapper: Wrapper,
            Carousel,
            Slide,
            Pagination,
            Navigation,
        },

        setup() {
            const toast = useToast();

            return { toast };
        },

        mixins: [seoMixin],

        data() {
            return {
                tabIndex: 0,

                categories: [],
                catalog: [],
                categoryTabs: 0,
                bestSellers: [],
                breakpoints: {
                    300: {
                        itemsToShow: 1,
                        snapAlign: "center",
                    },
                    960: {
                        itemsToShow: 5,
                        snapAlign: "start",
                    },
                },

                quantity: 1,
            };
        },

        async created() {
            this.categories = await catalogService.getHomePageCategories();
            this.bestSellers = await productService.getHomePageProducts();

            this.setImagesAttributes();
        },

        methods: {
            async requestQuote(productId) {
                let data = {
                    quantity: this.quantity,
                    shoppingCartType: ShoppingCartType.Wishlist
                };

                let response = await shoppingCartService.addProductToCartFromCatalog(productId, QueryUtils.transformObjectToQueryParams(data));

                if (response.errors !== null) {
                    this.showErrorMessages(response.errors);
                } else {
                    this.toast.success(QuoteToast);

                    this.emitter.emit('updateHeaderLinks', await wishlistService.getHeaderLinks());
                }
            },

            async addToCompareList(productId) {
                await productService.addProductToCompareList(productId);

                this.toast.success(CompareToast);
            },

            goTo(url) {
                this.$router.push(url);
            }
        }
    };
</script>